import { createSlice } from '@reduxjs/toolkit';
import { INewsDetailState } from '../types';
import { getLossBsosDetail } from '../../service/api';

const initialState: INewsDetailState = {
  page: null,
  pending: false,
  error: null,
};

export const lossBsosDetailSlice = createSlice({
  name: 'lossBsosDetailSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLossBsosDetail.pending, (state) => {
        state.pending = true;
        state.error = null;
      })
      .addCase(getLossBsosDetail.fulfilled, (state, action) => {
        state.page = action.payload;
        state.pending = false;
      })
      .addCase(getLossBsosDetail.rejected, (state, action) => {
        if (action.error.message !== undefined) {
          state.error = action.error.message;
        }
        state.pending = true;
      });
  },
});

export default lossBsosDetailSlice.reducer;
